import { AxiosError } from 'axios'

import { Category } from '@/types/api/api-v3/category'
import { LoadState } from '@/types/main'
import { ErrorData } from '@/types/api/api-v3/basket'

export type CategoryState = LoadState<Category[], AxiosError<ErrorData>>

export type SimpleCategoriesState = LoadState<Category[]>

// Перечисление для определения типа ивента counter-а
export enum SetProductType {
  INCREASE = 'INCREASE',
  DECREASE = 'DECREASE',
}

export type SetProductIncludeType = 'INCREASE' | 'DECREASE'
